import { render, staticRenderFns } from "./CustomerBillsView.vue?vue&type=template&id=fe0d1d62&scoped=true&"
import script from "./CustomerBillsView.vue?vue&type=script&lang=js&"
export * from "./CustomerBillsView.vue?vue&type=script&lang=js&"
import style0 from "./CustomerBillsView.vue?vue&type=style&index=0&id=fe0d1d62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe0d1d62",
  null
  
)

export default component.exports